var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaiting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "34px",
    viewBox: "-1 -1 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iPhoneX",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "S1013---my-campaigns-waiting/rejected",
    transform: "translate(-170.000000, -304.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(0.000000, 154.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-waiting",
    transform: "translate(170.000000, 150.000000)",
    stroke: "#000",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5192514,20.0460114 C14.9216043,19.5862829 14.5713557,18.8750514 14.5713557,18.1210771 L14.5713557,9.71443143 C14.5713557,8.37315571 15.6586757,7.28583571 16.9999271,7.28583571 C18.3412029,7.28583571 19.4284986,8.37315571 19.4284986,9.71440714 L19.4285229,16.9252243 L23.3378429,19.9323057 C24.4008286,20.7500786 24.5997286,22.2748571 23.7820286,23.3380857 C22.9643286,24.4010714 21.4394529,24.5999714 20.3763457,23.7822714 L15.5192514,20.0460114 Z",
    id: "Path",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,0 C7.61116714,0 0,7.61116714 0,17 C0,26.3888571 7.61116714,34 17,34 C26.3888571,34 34,26.3888571 34,17 C34,7.61116714 26.3888571,0 17,0 Z M4.85714286,17 C4.85714286,10.2936943 10.2936943,4.85714286 17,4.85714286 C23.7062571,4.85714286 29.1428571,10.2936943 29.1428571,17 C29.1428571,23.7062571 23.7062571,29.1428571 17,29.1428571 C10.2936943,29.1428571 4.85714286,23.7062571 4.85714286,17 Z",
    id: "Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaiting);
export default __webpack_public_path__ + "static/media/waiting.8642c763fd3322977c23f7f6aff041e8.svg";
export { ForwardRef as ReactComponent };